import type { EmptyState } from "../list.types"

export const normalizeEmpty = (empty: EmptyState) => {
	if (typeof empty === "string") return { title: empty }
	return empty
}
